(() => {
  if (customElements.get('autodiaz-product-route')) return;
  class ProductRoute extends HTMLElement {
    connectedCallback() {
      const catalog = window.AutoDiazCatalog;
      if (!catalog) return;
      for (const item of this.querySelectorAll('[data-route-family], [data-route-leaf]')) item.hidden = true;
      for (const link of this.querySelectorAll('a[href]')) {
        link.href = catalog.url(link.getAttribute('href')).toString();
      }
      try {
        const product = JSON.parse(this.querySelector('[data-route-product]').content.textContent);
        if (!catalog.isPart(product)) return;
        const result = catalog.classify(product);
        const family = catalog.families.find(item => item.id === result.family);
        const leaf = catalog.leaves[result.leaf];
        if (!family || !leaf) return;
        this.showLevel('[data-route-family]', family.title, catalog.familyUrl(family.id));
        if (catalog.normalize(leaf[0]) !== catalog.normalize(family.title)) {
          const href = new URL(catalog.familyUrl(family.id));
          href.searchParams.set('ad_type', result.leaf);
          this.showLevel('[data-route-leaf]', leaf[0], href.toString());
        }
      } catch (error) {
        return;
      }
    }
    showLevel(selector, label, href) {
      const item = this.querySelector(selector);
      const link = item.querySelector('a');
      link.textContent = label;
      link.href = href;
      item.hidden = false;
    }
  }
  customElements.define('autodiaz-product-route', ProductRoute);
})();
